import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HowItWorksSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '1',
    title: 'Audita tu luz',
    description: 'Sigue el ejercicio del mapa solar para saber qué puedes plantar realmente.'
  }, {
    number: '2',
    title: 'Monta tus 3 Macetas',
    description: 'Usa nuestra receta de sustrato y las especies velocistas recomendadas.'
  }, {
    number: '3',
    title: 'Cosecha y Repite',
    description: "Aplica la técnica 'Corta y Vuelve' para tener comida infinita durante toda la temporada."
  }];
  return <section ref={ref} className="w-full py-16 md:py-24 bg-white" data-id="element-65">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-67">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F] mb-4" data-id="element-68">
            Cómo Funciona
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-69">
            Tres pasos simples para tu primera cosecha
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-70">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2 + index * 0.1
        }} className="flex gap-6 items-start" data-id="element-71">
              <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#2D6A4F] to-[#40916C] rounded-full flex items-center justify-center shadow-lg" data-id="element-72">
                <span className="text-2xl font-bold text-white" data-id="element-73">
                  {step.number}
                </span>
              </div>
              <div className="flex-1 bg-[#D8F3DC] rounded-xl p-6" data-id="element-74">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-[#2D6A4F] mb-2" data-id="element-75">
                  {step.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-76">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}